// Function that actually does the counting
function countUp(targetEl, targetVal, duration, decimals) {
    if(!isFinite(targetVal)) return;

    const start = 0;
    const end = targetVal;

    // Use global performance API for more consistent time-based functionality
    const startTime = performance.now();

    /**
     * Custom ease-out function for number count animation
     * Expanded form for reference:
        function easeOutCubic(t) {
            // (Optionally clamp t into [0, 1] to be safe)
            // t = Math.min(1, Math.max(0, t));

            const inv = 1 - t;
            const decelCurve = inv * inv * inv; // (1 - t)^3 == (1 - t) ** 3 == Math.pow(1 - t, 3)
            return 1 - decelCurve;              // 1 - (1 - t)^3
        }
    */
    // Actual implementation we use:
    const easeOutCubic = t => 1 - ((1 - t) ** 3);

    const tick = (now) => {
        const t = Math.min(1, (now - startTime) / duration);
        const value = start + (end - start) * easeOutCubic(t);
        targetEl.textContent = value.toFixed(decimals);
        if(t < 1) {
            requestAnimationFrame(tick);
        } else {
            targetEl.textContent = end.toFixed(decimals);
        }
    };

    requestAnimationFrame(tick);
}

// Code to determine if the counter is in the user's viewport
const counters = document.querySelectorAll('.stat-columns .stat-counter');
const seen = new WeakSet(); // Used to automate "garbage collection" as code should only run once

if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries, obs) => {
        entries.forEach(entry => {
            if (entry.isIntersecting && !seen.has(entry.target)) {
                seen.add(entry.target); // ensure it only runs once
                const targetNumber = entry.target.getAttribute('data-target-number');
                const targetEl = entry.target.querySelector('span.number');
                const decimals = (targetNumber.split('.')[1] || '').length;

                countUp(targetEl, parseFloat(targetNumber), 1000, decimals);
                obs.unobserve(entry.target); // stop tracking this one
            }
        });
    }, {
        threshold: 0.2, // ~20% visible before starting
        rootMargin: '0px 0px -5% 0px' // start a bit before counter is fully in view
    });

    counters.forEach(el => io.observe(el));
} else {
    // Fallback for very old browsers runs on page load
    counters.forEach(counter => {
        const targetNumber = counter.getAttribute('data-target-number');
        const targetEl = counter.querySelector('span.number');
        const decimals = (targetNumber.split('.')[1] || '').length;
        countUp(targetEl, parseFloat(targetNumber), 1000, decimals);
    });
}